define('sentient/aba/models/SessionResultModel',[
    'underscore',
    'backbone',
    'loglevel',
    '../Percentile',
    'simple_statistics'
], function(_, Backbone, log, Percentile, ss) {
    var SessionResultModel = Backbone.Model.extend({
        defaults: {
            'RespId': null,
            'AppId': null,
            'ProjectId': null,
            'exercises': {},
            'pauses': [],
            'post-pause': []
        },
        initialize: function() {
            this.set('exercises', {});
            this.set('pauses', []);
            this.set('post-pause', []);
            this.set('repeats', {});
        },
        serviceHost: '//api.sds-aba.com',
        urlRoot: '/receiver/response',
        url: function() {
            var base = _.result(this, 'serviceHost') + _.result(this, 'urlRoot') || urlError();
            return [
                base,
                encodeURIComponent(this.get('ProjectId')),
                encodeURIComponent(this.get('RespId'))
            ].join('/');
        },
        clear: function() {
            this.set('exercises', {});
        },
        'addResult': function(
            uid,
            exerciseId,
            primeId,
            primeTime,
            taskId,
            taskSortTime,
            taskResult,
            taskAccuracy,
            taskSpeed,
            repeateId,
            eventType,
            eventData,
            target_type,
            selectedBucket,
            selectedBucketOrientation,
            rejectedBucket,
            rejectedBucketOrientation
        ) {
            //log.debug("addResult",arguments);
            var prime = null;
            if (primeId && primeTime) {
                prime = {
                    'name': primeId,
                    'primeTime': primeTime
                };
            }
            var sort = {
                'name': taskId,
                'time': taskSortTime,
                'result': taskResult
            };
            var exercises = this.get('exercises');
            //
            if (!exercises['exercise-' + exerciseId]) {
                exercises['exercise-' + exerciseId] = {
                    'tasks': {}
                };
            }



            var tasks = exercises['exercise-' + exerciseId]['tasks'];
            var record = {
                'stepUID': uid,
                'sort': sort,
                'accuracy': taskAccuracy,
                'speed': taskSpeed,
                'repeateId': repeateId
            };

            if (eventType) {
                _.extend(record, {
                    'response_type': eventType
                });
            }
            if (eventData) {
                _.extend(record, {
                    'response_intensity': eventData
                });
            }

            if (prime) {
                _.extend(record, {
                    'prime': prime
                });
            }


            if (target_type) {
                _.extend(record, {
                    'targetType': target_type
                });
            }

            if (selectedBucket) {
                _.extend(record, {
                    'selectedBucket': selectedBucket
                });
            }

            if (selectedBucketOrientation) {
                _.extend(record, {
                    'selectedBucketOrientation': selectedBucketOrientation
                });
            }

            if (rejectedBucket) {
                _.extend(record, {
                    'rejectedBucket': rejectedBucket
                });
            }

            if (rejectedBucketOrientation) {
                _.extend(record, {
                    'rejectedBucketOrientation': rejectedBucketOrientation
                });
            }


            //Create a string to thast is unique to this  exercise / prime / task so that we can see if this is a repeat
            var exerciseTaskPrimeId =
                'exercise(' + encodeURI(exerciseId.toString()) +
                '):prime(' + encodeURI((primeId ? primeId : 'noprime').toString()) +
                '):task(' + encodeURI(taskId.toString()) + ')';

            var repeats = this.get('repeats');
            //If the exerciseTaskPrimeId has been seen befor then increment it, else set it to one.
            repeats[exerciseTaskPrimeId] = (repeats[exerciseTaskPrimeId] ? repeats[exerciseTaskPrimeId] + 1 : 1);
            //Save the result so we can look it up in the next result save.
            this.set('repeats', repeats);

            _.extend(record, {
                'repeatId': repeats[exerciseTaskPrimeId]
            });


            //log.debug(uid,"uid.substring(uid.length - 10)",uid.substring(uid.length - 10));
            if (uid.substring(uid.length - 10) == 'post-pause') {
                _.extend(record, {
                    'exercise': exerciseId
                });
                var pauses = this.get('post-pause');
                var lastPauseIndix = pauses.length.toString();
                pauses[lastPauseIndix] = record;
            } else {
                var lastTaskIndix = 'task-' + _.keys(tasks).length.toString();
                tasks[lastTaskIndix] = record;
            }
            return;

        },
        getTaskTimeMean: function(exerciseId) {
            var exercises = this.get('exercises');
            if (!exercises['exercise-' + exerciseId]) {
                return 0;
            }
            var tasks = exercises['exercise-' + exerciseId]['tasks'];
            var taskCount = _(tasks).keys().length;
            var timeSum = _(tasks).foldl(function(memo, task) {
                //log.debug("SessionResultModel task",task.sort.time);
                return memo + task.sort.time;
            }, 0);
            //log.debug("SessionResultModel::getTaskTimeMean() = " + timeSum + "/" + taskCount + "="+(timeSum/taskCount));
            return (timeSum / taskCount);
        },
        getTaskAccuracyMean: function(exerciseId) {
            var exercises = this.get('exercises');
            if (!exercises['exercise-' + exerciseId]) {
                return 0;
            }
            var tasks = exercises['exercise-' + exerciseId]['tasks'];
            var taskCount = _(tasks).keys().length;
            var correctSum = _(tasks).foldl(function(memo, task) {
                //log.debug("SessionResultModel task",task.sort.result);
                if (task.sort.result == 'correct') {
                    return memo + 1;
                } else {
                    return memo;
                }
            }, 0);
            //log.debug("SessionResultModel::getTaskAccuracyMean() = " + correctSum + "/" + taskCount + "="+(correctSum/taskCount));
            return (correctSum / taskCount);
        },
        getCountOfCorrectTasks: function(exerciseId) {
            var exercises = this.get('exercises');
            if (!exercises['exercise-' + exerciseId]) {
                return 0;
            }
            var tasks = exercises['exercise-' + exerciseId]['tasks'];
            var correctSum = _(tasks).foldl(function(memo, task) {
                //log.debug("SessionResultModel task",task.sort.result);
                if (task.sort.result == 'correct') {
                    return memo + 1;
                } else {
                    return memo;
                }
            }, 0);
            return correctSum;
        },
        averageExerciseSpeed: function() {
            var exercises = this.get('exercises');
            var speedSum = 0;
            var exerciseCount = 0;
            _.each(exercises, function(exercise, index, exercises) {
                exerciseCount = exerciseCount + 1;
                //log.debug("avg Exercise accuracy:", exercise);
                var lastTask = _.last(_.keys(exercise.tasks));
                //log.debug("avg Exercise accuracy lastTask:", lastTask);
                speedSum = speedSum + exercise.tasks[lastTask]['speed'];
            });
            //log.debug("speedSum/exerciseCount:", speedSum,"/",exerciseCount);
            return speedSum / exerciseCount;
        },
        averageExerciseAccuracy: function() {
            var exercises = this.get('exercises');
            var accuracySum = 0;
            var exerciseCount = 0;
            _.each(exercises, function(exercise, index, exercises) {
                exerciseCount = exerciseCount + 1;
                //log.debug("avg Exercise accuracy:", exercise);
                var lastTask = _.last(_.keys(exercise.tasks));
                //log.debug("avg Exercise accuracy lastTask:", lastTask);
                accuracySum = accuracySum + exercise.tasks[lastTask]['accuracy'];
            });
            //log.debug("accuracySum/exerciseCount:", accuracySum,"/",exerciseCount);
            return accuracySum / exerciseCount;
        },
        subconsciousAssociations: function() {

            //Some math funtions;
            // Programmer: Larry Battle
            // Date: Mar 06, 2011
            // Purpose: Calculate standard deviation, variance, and average among an array of numbers.
            var isArray = function(obj) {
                return Object.prototype.toString.call(obj) === '[object Array]';
            },
                getNumWithSetDec = function(num, numOfDec) {
                    var pow10s = Math.pow(10, numOfDec || 0);
                    return (numOfDec) ? Math.round(pow10s * num) / pow10s : num;
                },
                getAverageFromNumArr = function(numArr, numOfDec) {
                    if (!isArray(numArr)) {
                        return false;
                    }
                    var i = numArr.length,
                        sum = 0;
                    while (i--) {
                        sum += numArr[i];
                    }
                    return getNumWithSetDec((sum / numArr.length), numOfDec);
                },
                getVariance = function(numArr, numOfDec) {
                    if (!isArray(numArr)) {
                        return false;
                    }
                    var avg = getAverageFromNumArr(numArr, numOfDec),
                        i = numArr.length,
                        v = 0;

                    while (i--) {
                        v += Math.pow((numArr[i] - avg), 2);
                    }
                    v /= numArr.length;
                    return getNumWithSetDec(v, numOfDec);
                },
                getStandardDeviation = function(numArr, numOfDec) {
                    if (!isArray(numArr)) {
                        return false;
                    }
                    var stdDev = Math.sqrt(getVariance(numArr, numOfDec));
                    return getNumWithSetDec(stdDev, numOfDec);
                };
            var tasks = {};
            var buckets = {};
            var primeResponseTimes = {};
            var primes = {};
            var primesDiffs = {};

            //console.log("subconsciousAssociations()");
            _.each(this.get('exercises'), function(exercise, exercisesIndex) {
                console.log("exercise", exercise);


                exercise.saSourceData = {
                    taskId: [],
                    responseTimes: [],
                    primes: [],
                    bucketOrientations: [],
                    taskResults: [],
                    negZScores: [],
                    count: 0
                };

                //Tasks pass #1: Caculate the z-scores for all good tasks
                _.each(exercise.tasks, function(task, taskId) {
                    //Filter out all tasks that timed-out
                    if (task && task.sort && task.sort.result && task.sort.result === "timeout") {
                        return false;
                    }
                    // OR are less then 140ms
                    if (task && task.sort && task.sort.time && task.sort.time <= 140) {
                        return false;
                    }

                    var responseTime, prime, bucketOrientation, taskResult;
                    responseTime = prime = bucket = taskResult = null;

                    if (task && task.sort && task.sort.time) {
                        responseTime = task.sort.time;
                    }

                    if (task && task.prime && task.prime.name) {
                        prime = task.prime.name;
                    }

                    if (task && task.bucketOrientation) {
                        bucketOrientation = task.selectedBucketOrientation;
                    }

                    if (task && task.sort && task.sort.result) {
                        taskResult = task.sort.result;
                    }

                    if (responseTime !== null && prime !== null && bucketOrientation !== null && taskResult !== null) {
                        exercise.saSourceData.taskId[exercise.saSourceData.count] = taskId;
                        exercise.saSourceData.responseTimes[exercise.saSourceData.count] = responseTime;
                        exercise.saSourceData.primes[exercise.saSourceData.count] = prime;
                        exercise.saSourceData.bucketOrientations[exercise.saSourceData.count] = bucketOrientation;
                        exercise.saSourceData.taskResults[exercise.saSourceData.count] = taskResult;
                        exercise.saSourceData.count++;
                    }

                });

                exercise.saSourceData.meanResponseTime = ss.mean(exercise.saSourceData.responseTimes);
                exercise.saSourceData.StDevResponseTime = ss.sample_standard_deviation(exercise.saSourceData.responseTimes);

                for (var i = exercise.saSourceData.responseTimes.length - 1; i >= 0; i--) {
                    exercise.saSourceData.negZScores[i] = -1 * ss.z_score(
                        exercise.saSourceData.responseTimes[i],
                        exercise.saSourceData.meanResponseTime,
                        exercise.saSourceData.StDevResponseTime
                    );
                    exercise.tasks[exercise.saSourceData.taskId[i]].negZScore = exercise.saSourceData.negZScores[i];
                }

                //log.debug("exercise.saSourceData", exercise.saSourceData);
                _.each(exercise.tasks, function(task, taskId) {

                    //Filter out all tasks that timed-out
                    if (task && task.sort && task.sort.result && task.sort.result === "timeout") {
                        return false;
                    }
                    // OR are less then 140ms
                    if (task && task.sort && task.sort.time && task.sort.time <= 140) {
                        return false;
                    }

                    if (task.prime && task.selectedBucket) {

                        var taskUidString = JSON.stringify({
                            id: task.stepUID,
                            exercise: exercisesIndex
                        });
                        if (typeof tasks[taskUidString] == 'undefined') {
                            tasks[taskUidString] = {
                                id: task.stepUID,
                                exercise: exercisesIndex,
                                prime: task.prime.name,
                                bucket: task.selectedBucket,
                                result: task.sort.result,
                                time: task.sort.time,
                                negZScore: task.negZScore
                            };
                        }

                        var primeUidString = JSON.stringify({
                            id: task.prime.name,
                            exercise: exercisesIndex
                        });
                        if (typeof primes[primeUidString] == 'undefined') {
                            primes[primeUidString] = {
                                id: task.prime.name,
                                exercise: exercisesIndex
                            };
                        }

                        var bucketUidString = JSON.stringify({
                            id: task.selectedBucket,
                            exercise: exercisesIndex
                        });
                        if (typeof buckets[bucketUidString] == 'undefined') {
                            buckets[bucketUidString] = {
                                id: task.selectedBucket,
                                orientation: task.selectedBucketOrientation,
                                exercise: exercisesIndex
                            };
                            //log.debug(bucketUidString,task);
                        }

                        var primeResponse = {
                            exercise: exercisesIndex,
                            prime: task.prime.name,
                            bucket: task.selectedBucket
                        };
                        var uidString = JSON.stringify(primeResponse);
                        if (typeof primeResponseTimes[uidString] == 'undefined') {
                            primeResponseTimes[uidString] = {
                                primeResponse: primeResponse,
                                times: [],
                                negZScore: []
                            };
                        }
                        primeResponseTimes[uidString].times.push(task.sort.time);
                        primeResponseTimes[uidString].negZScore.push(task.negZScore);
                    }
                    //console.log("task", task);

                });
            });

            //console.log("primeResponseTimes = ",primeResponseTimes);
            _.each(primeResponseTimes, function(primeResponse) {
                var sum = 0;
                sum = _.reduce(primeResponse.times, function(sum, time) {
                    return sum + time;
                }, 0);
                primeResponse.avgTime = sum / primeResponse.times.length;

                sum = 0;
                sum = _.reduce(primeResponse.negZScore, function(sum, negZScore) {
                    return sum + negZScore;
                }, 0);
                primeResponse.avgNegZScore = sum / primeResponse.negZScore.length;
                //console.log("primeResponse = ",primeResponse);
            });



            _.each(buckets, function(bucket) {
                _.each(primeResponseTimes, function(primeResponse) {
                    if (primeResponse.primeResponse.bucket == bucket.id && primeResponse.primeResponse.exercise == bucket.exercise) {
                        //console.log("primeResponse = ",primeResponse);
                        if (typeof bucket.avgTimes == 'undefined') {
                            bucket.avgTimes = [];
                        }
                        bucket.avgTimes.push(primeResponse.avgTime);
                    }
                });
                bucket.avgAvgTime = getAverageFromNumArr(bucket.avgTimes, 4);
                bucket.sdAvgTime = getStandardDeviation(bucket.avgTimes, 4);
                //console.log("bucket = ",bucket);
            });

            _.each(primeResponseTimes, function(primeResponse, id, primeResponseTimes) {
                var bucket = _.findWhere(buckets, {
                    id: primeResponse.primeResponse.bucket,
                    exercise: primeResponse.primeResponse.exercise
                });
                //console.log("bucket = ",bucket);
                if (bucket) {
                    primeResponse.bucket = bucket;
                    primeResponse.bucketOrientation = bucket.orientation;
                    primeResponse.bucketId = bucket.id;
                    primeResponse.exercise = bucket.exercise;
                    primeResponse.prime = primeResponse.primeResponse.prime;
                    primeResponse.zTransformedReactionTimes = (bucket.avgAvgTime - primeResponse.avgTime) / bucket.sdAvgTime;

                }
                //console.log("primeResponse = ",primeResponse);
            });

            _.each(primes, function(prime) {
                prime.diffZTransformedReactionTimes = 0;
                //console.log("primeResponseTimes = ", primeResponseTimes);
                _.chain(primeResponseTimes)
                    .values()
                    .where({
                        prime: prime.id,
                        exercise: prime.exercise,
                    })
                    .each(function(primeResponseTime, id) {
                        //console.log("primeResponseTime = ", primeResponseTime);
                        if (primeResponseTime.bucketOrientation === "up") {
                            prime.diffZTransformedReactionTimes += primeResponseTime.avgNegZScore;
                        } else {
                            prime.diffZTransformedReactionTimes -= primeResponseTime.avgNegZScore;
                        }
                        prime.CDFIndexedValues = ss.cumulative_std_normal_probability(prime.diffZTransformedReactionTimes);

                    });
            });

            var min = null;
            var max = null;
            _.each(primes, function(prime) {
                if (min === null) {
                    min = prime;
                }
                if (max === null) {
                    max = prime;
                }
                if (min.CDFIndexedValues > prime.CDFIndexedValues) {
                    min = prime;
                }
                if (max.CDFIndexedValues < prime.CDFIndexedValues) {
                    max = prime;
                }
            });

            //console.log("primeResponseTimes = ",primeResponseTimes);

            return {
                min: min,
                max: max,
                primesDiffs: primesDiffs,
                tasks: tasks,
                buckets: buckets,
                primeResponseTimes: primeResponseTimes,
                primes: primes
            };
        }
    });
    return SessionResultModel;
});
